<template>
  <div class="panel" :class="{ 'panel-with-footer': !isLoading }">
    <div v-if="isLoading">
      <div class="px-5 pb-5"><news-loading-skeleton /></div>
    </div>
    <div v-else>
      <div class="panel-body-lg">
        <div class="pb-3">
          <div class="d-flex flex-column flex-lg-row justify-content-lg-between">
            <h2>Top stories at Autodesk</h2>
            <summarize-news-button :key="$route.fullPath" />
          </div>
        </div>
        <div class="alert alert-error" v-if="isErrored">
          {{ CONSTANTS.SERVER_ERROR_MESSAGE }}
        </div>
        <div v-else>
          <div v-if="posts && posts.length > 0">
            <div v-if="featuredPost">
              <news-card-featured :post-data="featuredPost" />
            </div>
            <div v-if="posts" class="row pr-lg-5 pb-3 pt-4 pt-md-1">
              <div
                v-for="post in posts"
                :key="post.hitId"
                class="col-12 col-xl-6"
              >
                <news-card class="pr-lg-3 pb-4" :post-data="post" />
              </div>
            </div>
          </div>
          <div class="pb-5" v-else>No top stories to display</div>
        </div>
      </div>
      <div class="panel-footer-wrapper">
        <panel-footer
          :text="'View all stories'"
          :router-link-to="{ path: 'news' }"
          :event-name="'Top stories panel view all clicked'"
        />
      </div>
    </div>
  </div>
</template>

<script>
import api from "@/api";
import * as CONSTANTS from "@/store/constants";

import NewsCard from "./NewsCard";
import NewsCardFeatured from "./NewsCardFeatured";
import NewsLoadingSkeleton from "./NewsLoadingSkeleton";
import PanelFooter from "../panels/PanelFooter";
import SummarizeNewsButton from '../buttons/SummarizeNewsButton';

export default {
  name: "top-stories-panel",
  components: {
    NewsCard,
    NewsCardFeatured,
    NewsLoadingSkeleton,
    PanelFooter,
    SummarizeNewsButton 
  },
  data() {
    return {
      CONSTANTS,
      isLoading: false,
      isErrored: false,
      featuredPost: null,
      posts: null,
      queryConfig: {
        size: 7,
        offset: 0,
      },
    };
  },
  created() {
    this.getNewsPosts();
  },

  methods: {
    async getNewsPosts() {
      this.isLoading = true;
      try {
          let res = await api.getNewsPosts(
          this.queryConfig.offset,
          this.queryConfig.size
        );
        let posts = res.data.data.news.news;
        this.featuredPost = JSON.parse(JSON.stringify(posts[0]));
        posts.splice(0, 1);
        this.posts = posts;
      } catch (e) {
        this.isErrored = true;
      } finally {
        this.isLoading = false;
      }
    },
  },
};
</script>

<style scoped>
.panel {
  padding-top: 25px;
  padding-left: 0 !important;
  padding-right: 0 !important;
  min-height: 500px;
  position: relative;
  margin-bottom: 0px;
}
.panel-body {
  padding-left: 4rem;
  padding-right: 4rem;
}
.panel-with-footer {
  padding-bottom: 80px;
}
.panel-footer-wrapper {
  position: absolute;
  bottom: 0;
  right: 0;
  left: 0;
}
</style>
